'use client';

import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui';

type PaymentMethod = {
  brand: string;
  last4: string;
  expMonth: number;
  expYear: number;
};

type BillingDetailsCardProps = {
  paymentMethod: PaymentMethod | null | undefined;
  onUpdatePaymentMethod: () => void;
  isAdmin?: boolean;
};

export function BillingDetailsCard({
  paymentMethod,
  onUpdatePaymentMethod,
  isAdmin = false,
}: BillingDetailsCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Payment Method</CardTitle>
      </CardHeader>
      <CardContent className="pt-4">
        {paymentMethod ? (
          <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:gap-4">
            <div className="bg-muted flex h-10 w-20 shrink-0 items-center justify-center rounded px-2 text-xs font-semibold uppercase">
              {paymentMethod.brand}
            </div>
            <div className="space-y-1.5">
              <div className="font-semibold">•••• {paymentMethod.last4}</div>
              <div className="text-muted-foreground text-sm">
                Expires {paymentMethod.expMonth}/{paymentMethod.expYear}
              </div>
            </div>
          </div>
        ) : (
          <div className="text-muted-foreground text-sm">
            No payment method on file.
          </div>
        )}
        {isAdmin && (
          <div className="mt-4">
            <Button variant="outline" onClick={onUpdatePaymentMethod}>
              Update Payment Method
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
